<template>
  <b-row class="OBForm">
    <b-col cols="12" lg="10" offset-lg="1">
      <Notification v-bind.sync="notification" />
      <Notification v-bind.sync="loadingNotification" />

      <OBCard
        ref="ob_card"
        :employee="userEmployeeData"
        :others="otherData"
        @submit="submitOB"
      />
    </b-col>
  </b-row>
</template>
<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import Notification from '@/components/Notification';
import OBCard from '@/components/OBCard';
import ResourceService from '@/services/ResourceService';

const resource = new ResourceService();

export default {
  name: 'OBForm',
  components: {
    Notification,
    OBCard,
  },
  mounted() {
    const { id } = this.userData;
    if (id) {
      this.getUserEmployeeData();
    } else {
      this.setNotification({
        show: true,
        variant: 'danger',
        message: 'User not found',
        refresh: true,
      });
    }
  },
  data() {
    return {
      userEmployeeData: {},
      loadingUserEmployeeData: false,
    };
  },
  computed: {
    otherData() {
      return {
        loadingEmployee: this.loadingUserEmployeeData,
      };
    },
    loadingNotification() {
      return {
        show: this.isLoadingRequest,
        variant: 'light',
        message: 'Submitting Official Business...',
        icon: { name: 'circle-notch', spin: true },
      };
    },
    ...mapGetters(['isApprover', 'userData', 'isLoadingRequest']),
    ...mapState(['notification']),
  },
  methods: {
    /**
     * Get odoo employee data for user
     */
    getUserEmployeeData() {
      const { id } = this.userData;
      this.loadingUserEmployeeData = true;
      resource.get(`/user/${id}`)
        .then((result) => {
          const { data } = result || {};
          // save user data
          this.userEmployeeData = data || {};
        })
        .catch((response) => {
          const { status, statusText: data } = response;
          const error = { status, data };

          const errorMessage = this.$get(error, 'data', 'An error occurred');
          this.setNotification({
            show: true,
            variant: 'danger',
            message: errorMessage,
            refresh: true,
            icon: {
              name: 'exclamation-triangle',
              class: 'text-danger',
            },
          });
        })
        .then(() => {
          this.loadingUserEmployeeData = false;
        });
    },
    /**
     * Submit overtime application
     */
    submitOB(formData) {
      const userID = this.$get(this.userData, 'id', null);
      const payload = {
        userID,
        ...formData,
      };

      this.startLoadingRequest();
      this.startLoadingPage();
      resource.post('/ob/submit', payload)
        .then(({ success, message }) => {
          if (success) {
            this.setNotification({
              show: true,
              variant: 'success',
              message: message || 'Application sent for approval.',
              icon: { name: 'check' },
            });

            this.resetForm();
          } else {
            this.setNotification({
              show: true,
              variant: 'danger',
              message: message || 'An error occurred.',
              refresh: true,
              icon: {
                name: 'exclamation-triangle',
                class: 'text-danger',
              },
            });
          }
        })
        .catch((response) => {
          const { status, statusText: data } = response;
          const error = { status, data };

          const errorMessage = this.$get(error, 'data', 'An error occurred');
          this.setNotification({
            show: true,
            variant: 'danger',
            message: errorMessage,
            refresh: true,
            icon: {
              name: 'exclamation-triangle',
              class: 'text-danger',
            },
          });
        })
        .then(() => {
          this.stopLoadingRequest();
          this.stopLoadingPage();
        });
    },
    resetForm() {
      this.$refs.ob_card.resetForm();
    },
    ...mapActions([
      'startLoadingRequest',
      'stopLoadingRequest',
      'startLoadingPage',
      'stopLoadingPage',
      'setNotification',
    ]),
  },
};
</script>
